import { render } from "./MaestroActivosModal.vue?vue&type=template&id=c6f58840&scoped=true"
import script from "./MaestroActivosModal.vue?vue&type=script&lang=js"
export * from "./MaestroActivosModal.vue?vue&type=script&lang=js"

import "./MaestroActivosModal.vue?vue&type=style&index=0&id=c6f58840&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6f58840"]])

export default __exports__